/*
 * Разделитель дня (prototype/Prototype.dc.html:1491).
 *
 * `margin: 6px 0 4px` — из копии КАРТОЧКИ. Копия экрана «Чаты» (1358) даёт `4px 0`; справочник
 * (docs/reference/phase-2-mockup.md, раздел 4) сводит обе к числам карточки.
 */
.root {
  display: flex;
  justify-content: center;
  margin: 6px 0 4px;
}

.pill {
  padding: 3px 12px;
  border: 1px solid var(--line-2);
  border-radius: 999px;
  background: var(--panel);
  font-family: 'JetBrains Mono Variable', monospace;
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--ink-3);
}
